import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  collapsibleRowContainer: {
    padding: theme.spacing(1, 1, 1, 8),
  },
}));

export default useStyles;
